/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListOf1OfPanelSettingAdminDto } from '../models/ListOf1OfPanelSettingAdminDto';
import type { PanelSettingAdminDto } from '../models/PanelSettingAdminDto';
import type { PostPutPanelSettingRequestAdmin } from '../models/PostPutPanelSettingRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PanelSettingsService {
    /**
     * **Required Policy:** `ViewPanelSettings`
     * @returns ListOf1OfPanelSettingAdminDto OK
     * @throws ApiError
     */
    public static getPanelSettingsAdmin(): CancelablePromise<ListOf1OfPanelSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/panelsettings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns PanelSettingAdminDto OK
     * @throws ApiError
     */
    public static postPanelSettingAdmin({
        requestBody,
    }: {
        requestBody?: PostPutPanelSettingRequestAdmin,
    }): CancelablePromise<PanelSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/panelsettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePanelSettings`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePanelSettingAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/panelsettings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
